import axios from 'axios';
import { Message } from 'element-ui';
import router from '@/router'
// 创建axios实例
const service = axios.create({
    baseURL: '/api',
    // baseURL: '/',
    timeout: 60000,
    headers: {
        'Content-Type': 'application/json;charset=utf-8'
    }
});

// 请求拦截器
service.interceptors.request.use(
    config => {
        // 添加token
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `${token}`;
        }
        return config;
    },
    error => {
        console.error('请求拦截器错误:', error);
        return Promise.reject(error);
    }
);
// 登录过期状态锁
let isRefreshing = false;
// 响应拦截器
service.interceptors.response.use(
    response => {
        const res = response.data;
        if (res.code && res.code != 0 && res.code != 7) {
            Message({
                message: res.codeMsg,
                type: 'error',
            });
            return res;
        } else if (res.code && res.code == 7) {
            if (!isRefreshing) {
                isRefreshing = true;
                localStorage.removeItem('token')
                Message({
                    message: '登录过期，请重新登录',
                    type: 'error',
                });
                setTimeout(() => {
                    router.replace({
                        path: '/Login'
                    }).catch(err => {
                        console.log('输出报错', err)
                    })
                    isRefreshing = false; // 重置状态
                }, 1000)
            }
            return res;
        } else {
            return res;
        }
    },
);

export default service;